import axios from "axios";
import API_BASE_URL from "../config";

const getEventServices = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/events/`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw new Error('Error getting events');
    }
}

export default getEventServices;